
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iOZNd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3102941aeaf81008181a03ae19b6c101>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db3cd447f930cb17$var$_react = $db3cd447f930cb17$var$_interopRequireDefault((parcelRequire("cozmU")));

var $db3cd447f930cb17$var$_iconNew = $db3cd447f930cb17$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $db3cd447f930cb17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldDropdown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/field-dropdown
 * Usage guidance:
 * Known uses: Dropdown field type in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db3cd447f930cb17$var$FieldDropdownIcon = (props)=>/*#__PURE__*/ $db3cd447f930cb17$var$_react.default.createElement($db3cd447f930cb17$var$_iconNew.default, Object.assign({
        name: "FieldDropdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 3.5H0V2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H0v-1.5h14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5M9 8.19 7.03 6.22 5.97 7.28l2.5 2.5a.75.75 0 0 0 1.06 0l2.5-2.5-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$db3cd447f930cb17$var$FieldDropdownIcon.displayName = 'FieldDropdownIcon';
var $db3cd447f930cb17$var$_default = module.exports.default = $db3cd447f930cb17$var$FieldDropdownIcon;

});


//# sourceMappingURL=field-dropdown.4a6ff0a3.js.map
